import React from 'react';
import { motion } from 'framer-motion';
export function PhilosophySection() {
  const statements = ['Selective by design.', 'Conviction over consensus.', 'Long-term perspective.'];
  return <section className="py-20 sm:py-28 md:py-32 px-4 sm:px-6 flex flex-col items-center justify-center" data-id="element-71">
      <div className="w-full max-w-4xl flex flex-col items-center space-y-14 sm:space-y-24 md:space-y-32" data-id="element-72">
        {statements.map((statement, index) => <motion.div key={index} initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.8,
        ease: 'easeOut',
        delay: index * 0.15
      }} className="text-center" data-id="element-73">
            <h2 className="font-heading text-lg sm:text-xl md:text-3xl text-brand-offWhite font-light uppercase tracking-[0.15em] sm:tracking-widest" data-id="element-74">
              {statement}
            </h2>
          </motion.div>)}
      </div>
    </section>;
}